module.exports = __webpack_public_path__ + "static/media/zoom-logo.2ff68220.png";